import { Image, Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { MULTI_TOUCHPOINT_ITEMS } from '@utils/constants';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { SafeImage } from '../SafeImage';

interface MultiTouchPointProps {
  event: PublicEventDetailsResponse;
}

const MultiTouchPoint = ({ event }: MultiTouchPointProps) => {
  const { t } = useTranslation();

  return (
    <View style={{ ...globalStyles.body, paddingTop: 20 }}>
      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor,
          marginBottom: 0,
          marginTop: 0,
        }}
      >
        {t('multi-touch-point')}
      </Text>

      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
          marginTop: 0,
        }}
      />

      <Text style={{ ...styles.title, paddingBottom: 0 }}>
        {t('multi-touch-point-networking-experience')}
      </Text>

      <View style={styles.multiTouchPointWrapper}>
        {MULTI_TOUCHPOINT_ITEMS(t, event?.name ?? '')?.map((item, index) => {
          const isEven = index % 2 === 0;

          return (
            <View
              style={{
                ...styles.multiTouchPointItem,
                flexDirection: isEven ? 'row' : 'row-reverse',
              }}
              wrap={false}
              key={item.title}
            >
              <View style={styles.textWrapper}>
                <Text
                  style={{
                    ...styles.itemTitle,
                    color: event?.design?.themeColor ?? 'black',
                  }}
                >
                  {item.title}
                </Text>
                <Text style={styles.itemSubtitle}>{item.text}</Text>
              </View>
              <View style={styles.imageWrapper}>
                <SafeImage
                  style={{
                    ...styles.image,
                    borderTopRightRadius: isEven ? '4px' : 0,
                    borderBottomRightRadius: isEven ? '4px' : 0,
                    borderTopLeftRadius: !isEven ? '4px' : 0,
                    borderBottomLeftRadius: !isEven ? '4px' : 0,
                  }}
                  src={item.img}
                  debugLabel={`multi-touchpoint-image-${index}`}
                />
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default MultiTouchPoint;
